var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconKultur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_3781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 93.4234H20V96.7568H3.33333V93.4234ZM80.0901 93.4234H96.7568V96.7568H80.0901V93.4234ZM6.66667 86.7568H16.6667V90.0901H6.66667V86.7568ZM20 86.7568H80.0901V90.0901H63.4234V93.4234H76.7568V96.7568H23.3333V93.4234H35.045V90.0901H20V86.7568ZM83.4234 86.7568H93.4234V90.0901H83.4234V86.7568ZM13.3333 80.0901H86.7568V83.4234H13.3333V80.0901ZM16.6667 30H20V76.7568H16.6667V30ZM23.3333 30H76.7568V76.7568H23.3333V30ZM80.0901 30H83.4234V76.7568H80.0901V30ZM10 13.3333H90.0901V26.6667H10V13.3333ZM6.66667 10V30H13.3333V76.7568H10V83.4234H3.33333V90.0901H0V100.09H100.09V90.0901H96.7568V83.4234H90.0901V76.7568H86.7568V30H93.4234V10H6.66667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0907 16.6666C51.8925 16.6666 53.4241 18.1981 53.4241 19.9999C53.4241 21.8017 51.8925 23.3333 50.0907 23.3333C48.2889 23.3333 46.7574 21.8017 46.7574 19.9999C46.7574 18.1981 48.1988 16.6666 50.0907 16.6666ZM43.334 19.9999C43.334 23.6936 46.307 26.6666 50.0007 26.6666C53.6943 26.6666 56.6673 23.6936 56.6673 19.9999C56.6673 16.3062 53.6943 13.3333 50.0007 13.3333C46.397 13.3333 43.334 16.3062 43.334 19.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 16.6666C28.4685 16.6666 30 18.1981 30 19.9999C30 21.8017 28.4685 23.3333 26.6667 23.3333C24.8649 23.3333 23.3333 21.8017 23.3333 19.9999C23.3333 18.1981 24.8649 16.6666 26.6667 16.6666ZM20 19.9999C20 23.6936 22.973 26.6666 26.6667 26.6666C30.3604 26.6666 33.3333 23.6936 33.3333 19.9999C33.3333 16.3062 30.3604 13.3333 26.6667 13.3333C22.973 13.3333 20 16.3062 20 19.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4235 16.6666C75.2253 16.6666 76.7568 18.1981 76.7568 19.9999C76.7568 21.8017 75.2253 23.3333 73.4235 23.3333C71.6217 23.3333 70.0902 21.8017 70.0902 19.9999C70.0902 18.1981 71.5316 16.6666 73.4235 16.6666ZM66.7568 19.9999C66.7568 23.6936 69.7298 26.6666 73.4235 26.6666C77.1172 26.6666 80.0902 23.6936 80.0902 19.9999C80.0902 16.3062 77.1172 13.3333 73.4235 13.3333C69.7298 13.3333 66.7568 16.3062 66.7568 19.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 18.3784H36.667V21.7118H40.0003V18.3784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4232 18.3784H60.0898V21.7118H63.4232V18.3784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 18.3784H13.333V21.7118H16.6663V18.3784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7562 18.3784H83.4229V21.7118H86.7562V18.3784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7113 90.0901H38.3779V93.4234H41.7113V90.0901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9995 34.0541L34.3238 38.3784L31.7112 40.9911L27.3869 36.6667L29.9995 34.0541ZM30.54 44.5046C31.1707 45.1352 32.2517 45.1352 32.8824 44.5046L37.9274 39.4595C38.558 38.8289 38.558 37.7478 37.9274 37.1172L31.2608 30.4505C30.6301 29.8199 29.549 29.8199 28.9184 30.4505L23.8734 35.4956C23.2427 36.1262 23.2427 37.2073 23.8734 37.8379L30.54 44.5046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5386 43.8388L37.1816 46.1958L40.4942 49.5083L42.8512 47.1513L39.5386 43.8388Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.757 40H41.7119V43.3333H46.757V40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 48.3784H33.333V53.4235H36.6663V48.3784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7027 36.6667L68.3784 40.9911L65.7658 38.3784L70.0901 34.0541L72.7027 36.6667ZM62.2523 37.2073C61.6216 37.8379 61.6216 38.919 62.2523 39.5496L67.2973 44.5947C67.9279 45.2253 69.009 45.2253 69.6397 44.5947L76.3063 37.928C76.937 37.2974 76.937 36.2163 76.3063 35.5856L71.2613 30.5406C70.6306 29.91 69.5496 29.91 68.9189 30.5406L62.2523 37.2073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 43.9162L57.1875 47.2288L59.5445 49.5858L62.857 46.2732L60.5 43.9162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4679 40H53.4229V43.3333H58.4679V40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7572 48.3784H63.4238V53.4235H66.7572V48.3784Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_3781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconKultur);
export default __webpack_public_path__ + "static/media/Nav-Icon-Kultur.c9ad0213fc9c7fcbbf63a4430071870d.svg";
export { ForwardRef as ReactComponent };